module.exports = __webpack_public_path__ + "img/CM-MC-25-Volvo-Lifestyle.8e29de99.jpg";